import { Button as DialogButton } from '@/ui'
import { Box, Button, Dialog, DialogContent, DialogTitle } from '@mui/material'
import cn from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from '../ContractCard.module.scss'
import CloseButton from '@/components/CloseButton/CloseButton'

export const RevertModal = ({ title = 'revoke', onClose, onRevert, isOpen }) => {
	const { t } = useTranslation()

	return (
		<Dialog classes={{ paper: styles.dialog }} onClose={onClose} open={isOpen}>
			<Box>{onClose ? <CloseButton onClose={onClose}></CloseButton> : null}</Box>
			<DialogTitle classes={{ root: styles.sign__title }}>{t(title)}</DialogTitle>
			<DialogContent sx={{ paddingBottom: '40px' }}>
				<div className={styles.dialog__buttons__wrapper}>
					<div className={styles.reset__button__wrapper}>
						<DialogButton type="button" onClick={onRevert}>
							{t('actions.revoke')}
						</DialogButton>
					</div>
					<Button
						type="button"
						variant="text"
						classes={{ root: cn(styles.button, styles.reset__button, styles.reset__button) }}
						onClick={onClose}
					>
						{t('cancel')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}
